import styled from 'styled-components';
import { Color } from '@brokerbay/elements-web';
import { Color as NewColor } from '@bb/elements-web-rebranding';
import Layout from '../Layout';
import { Title } from '../Typography';
import theme from '../theme';

const numberOfRows = 5;

export const StyledHeader = styled(Layout.Header)<{
  $showShadow: boolean;
  $marginTop: number;
  $marginLeft: number;
  $transition: number;
  $height: number;
  $pageTop: boolean;
  $visible: boolean;
  $hasShowingsMadeEasyFeature?: boolean;
  $hasSupraRebrandingFeature?: boolean;
}>`
  ${({ $visible }) => !$visible && 'display: none;'}
  && {
    position: fixed;
    left: 0;
    right: 0;
    margin-top: ${({ $marginTop }) => $marginTop}px;
    margin-left: ${({ $marginLeft }) => $marginLeft}px;
    height: ${({ $height }) => $height}px;
    background-color: ${({
      $hasShowingsMadeEasyFeature,
      $hasSupraRebrandingFeature,
    }) =>
      $hasShowingsMadeEasyFeature
        ? $hasSupraRebrandingFeature
          ? NewColor.PRIMARY
          : Color.PRIMARY
        : Color.WHITE};
    box-shadow: ${({ $showShadow, $pageTop }) =>
      $showShadow && !$pageTop && theme.getElevation('bottom')};
    padding: 0 10px;
    z-index: 1000;
    transition: all ${({ $transition }) => $transition}s;
  }
`;

export const StyledHeaderContent = styled.div<{
  $isMobile: boolean;
  $height: number;
  $isHidden?: boolean;
  $isAssetsHidden?: boolean;
  $isChatHidden?: boolean;
  $isExternal?: boolean;
}>`
  && {
    .app-header-button {
      width: 100%;
    }
    > .grid {
      ${({
        $isMobile,
        $isHidden,
        $height,
        $isAssetsHidden,
        $isChatHidden,
        $isExternal,
      }) => {
        if ($isMobile) {
          return `
            box-shadow: ${!$isHidden && theme.getElevation('bottom')};
            overflow: hidden;
            height: ${
              $isHidden
                ? 0
                : `${
                    $height *
                    (numberOfRows -
                      ($isAssetsHidden && 1) -
                      ($isChatHidden && 1))
                  }px`
            };
            transition: height 0.5s;
          `;
        }
        return `
          display: grid;
          grid-template-columns: 1fr auto 25px ${
            $isAssetsHidden ? '' : '25px'
          } 25px ${$isChatHidden ? '' : '25px'} 50px;
          grid-column-gap: 25px;
          align-items: center;
          ${$isExternal && 'height: 64px;'}
        `;
      }}
    }
  }
`;

export const StyledHeaderItem = styled.div<{
  $isMobile: boolean;
  $showBackgroundColor?: boolean;
  $height: number;
  $hasShowingsMadeEasyFeature?: boolean;
}>`
  && {
    display: grid;
    position: relative;
    ${({ $isMobile }) => $isMobile && `grid-template-columns:  50px 1fr 50px;`}
    height: ${({ $height }) => $height}px;
    width: 100%;
    align-items: center;
    ${({ $hasShowingsMadeEasyFeature }) =>
      $hasShowingsMadeEasyFeature && `justify-content: start;`}

    ${({ $showBackgroundColor, $isMobile, $hasShowingsMadeEasyFeature }) =>
      !($hasShowingsMadeEasyFeature && !$isMobile) &&
      $showBackgroundColor &&
      `background-color: ${theme.gray1};`}

    > :first-child {
      margin: auto;
    }
    > :last-child {
      display: flex;
      align-items: center;
      text-align: center;
    }

    > div > button {
      ${({ $isMobile, $hasShowingsMadeEasyFeature }) =>
        $hasShowingsMadeEasyFeature && $isMobile && `background: transparent;`}
    }

    .mobile-button {
      display: flex;
      height: 45px;
      width: 45px;
      align-items: center;
      justify-content: center;
      ${({ $hasShowingsMadeEasyFeature }) =>
        $hasShowingsMadeEasyFeature &&
        `:hover {
        background-color: transparent;
      }
    }`}
  }
`;

export const StyledTitle = styled(Title)<{
  $hide: boolean;
  $hasShowingsMadeEasyFeature?: boolean;
}>`
  && {
    ${({ $hasShowingsMadeEasyFeature }) =>
      $hasShowingsMadeEasyFeature && `color: ${Color.WHITE}`};
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    opacity: ${({ $hide }) => ($hide ? 0 : 1)};
    transition: all 0.2s;
  }
`;
